import { jsx } from "react/jsx-runtime";
import Accordion from "../../../../../dataDisplay/Accordion/Accordion.js";
import { L as LinkListStyles } from "./LinkListInner.js";
import LinkListMiddle from "./LinkListMiddle.js";
const LinkList = (props) => {
  const { links, openMenu } = props;
  const resolveLabelLink = (href, content) => !!(href && content);
  const resolveChevron = (items, href, chevron) => {
    if (chevron) {
      return chevron;
    }
    if (!items && href) {
      return "ArrowUpRight";
    }
    return void 0;
  };
  return /* @__PURE__ */ jsx(
    Accordion,
    {
      closedIcon: "Plus",
      openIcon: "Minus",
      className: LinkListStyles.accordionLevel1,
      disableChevronRotation: true,
      items: links && links.length > 0 ? links.map((group, rootIndex) => ({
        label: group.header,
        labelLink: resolveLabelLink(group.href, group.items) ? group.href : void 0,
        value: `${group.header}${rootIndex}`,
        icon: group.icon,
        iconVariant: group.iconVariant,
        fw: group.icon ? 400 : 600,
        href: !resolveLabelLink(group.href, group.items) ? group.href : void 0,
        chevron: resolveChevron(group.items, group.href),
        content: group.items || group.special ? /* @__PURE__ */ jsx(
          LinkListMiddle,
          {
            links: group,
            resolveChevron,
            openMenu
          }
        ) : void 0
      })) : []
    }
  );
};
export {
  LinkList as default
};
